// Centralised React Query keys — avoids string drift across files.

export const qk = {
  me: ['me'] as const,
  passport: ['me', 'passport'] as const,
  family: ['me', 'family'] as const,
  location: ['me', 'current-location'] as const,
  locale: ['me', 'locale'] as const,
  autoBookingSettings: ['me', 'auto-booking-settings'] as const,
  autoBookingStatus: ['me', 'auto-booking-status'] as const,
  bookingPriorities: ['me', 'booking-priorities'] as const,
  paymentMethods: ['me', 'payment-methods'] as const,

  wallet: ['wallet'] as const,
  walletTx: ['wallet', 'transactions'] as const,

  subscriptionPlans: ['subscriptions', 'plans'] as const,
  subscriptionMe: ['subscriptions', 'me'] as const,

  safetyCurrent: ['safety-score', 'me', 'current'] as const,
  safetyBreakdown: ['safety-score', 'me', 'breakdown'] as const,
  safetyHistory: (days: number) => ['safety-score', 'me', 'history', days] as const,
  safetyByCountry: (code: string) => ['safety-score', 'by-country', code] as const,

  news: (params: Record<string, string | number | undefined>) =>
    ['news', params] as const,
  newsItem: (id: string) => ['news', id] as const,

  bookings: (params: Record<string, string | number | undefined>) =>
    ['bookings', params] as const,
  bookingDetails: (id: string) => ['bookings', id] as const,

  tours: (params: Record<string, string | number | undefined>) => ['tours', params] as const,
  tourDetails: (id: string) => ['tours', id] as const,
  tourPurchases: ['tour-purchases'] as const,

  notifications: (params: Record<string, string | number | boolean | undefined>) =>
    ['notifications', params] as const,
  notificationSettings: ['notifications', 'settings'] as const,

  countries: ['reference', 'countries'] as const,
  cities: (code: string, q?: string) => ['reference', 'cities', code, q ?? ''] as const,
  locales: ['reference', 'locales'] as const,
  triggerTypes: ['reference', 'trigger-event-types'] as const,

  company: ['employer', 'company'] as const,
  employees: (params: Record<string, string | undefined>) =>
    ['employer', 'employees', params] as const,
  employee: (id: string) => ['employer', 'employees', id] as const,
  payouts: (params: Record<string, string | undefined>) =>
    ['employer', 'payouts', params] as const,

  supportTickets: ['support', 'tickets'] as const,
  supportTicket: (id: string) => ['support', 'tickets', id] as const,
};
